import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { irisIcon } from '@sondermind/iris/icon';
import { Required, IrisButtonTypeAttributeOptions, IrisButtonTarget } from '@sondermind/iris/shared';

import { IrisIconButtonTypes } from './enums/icon-button-type.enum';

@Component({
  selector: 'iris-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IrisIconButtonComponent implements OnInit {
  private irisIconButtonTypes = IrisIconButtonTypes;

  @Input() @Required ariaLabel!: string;
  @Input() disabled: boolean = false;
  @Input() linkHref: string = '';
  @Input() target: IrisButtonTarget | undefined;
  @Input() type: IrisIconButtonTypes = this.irisIconButtonTypes.SECONDARY;
  @Input() typeAttribute: IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions.SUBMIT;
  @Input() icon!: irisIcon;

  @Output() click: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  iconButtonClasses: string = '';

  ngOnInit(): void {
    this.iconButtonClasses = `iris-icon-button iris-icon-button--${this.type}`;
  }

  onClick(event: MouseEvent): void {
    event.stopImmediatePropagation();
    if (!this.disabled) {
      this.click.emit(event);
    }
  }
}
